import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as p5 from 'p5';
import { FullScreenService } from 'src/app/service/fullscreen.service';


@Component({
  selector: 'app-get-resolution',
  templateUrl: './get-resolution.component.html',
  styleUrls: ['./get-resolution.component.css']
})
export class GetResolutionComponent implements OnInit {

  @Input() fullScreen: boolean
  @Input() setFullScreen
  @Input() setResolution
  @Input() endGettingResolution

  //strings for translations
  msg1: string
  msg2: string

  constructor(public fullScreenService: FullScreenService, public translate: TranslateService) { 
    this.getTranslatedStrings()
  }

  getTranslatedStrings(){
    this.translate.get(['MP_P12', 'MP_P13'])
    .subscribe(translations => {
        this.msg1 = translations['MP_P12']
        this.msg2 = translations['MP_P13']
    })
}

  ngOnInit(): void {

    //make full screen 
    //this.fullScreenService.open()
    this.setFullScreen(true)
    this.fullScreenService.setFullScreen(true)
    const setFullScreenParam = this.fullScreenService.setFullScreen

    const setRes = this.setResolution
    const resetFullScreen = this.setFullScreen
    const endGettingRes = this.endGettingResolution

    var cardPixW;
    var cardPixH;
    let BCRW = 85.60; // bank card or similar actual width in mm
    let BCRH = 53.98; // bank card or similar actual height in mm
    //let screenRes = "${q://QID23/ChoiceTextEntryValue/4}"; // screen resolution through qualtrics
    var windowWH = [window.screen.width, window.screen.height]

    let msg1 = this.msg1
    let msg2 = this.msg2

    /* create sketch environment */
    var sketch = function (p) {


      let x = (windowWH[0] / 4); //
      let y = (windowWH[1] / 4);
      var w = 200;
      var h = 150;

      var header = ['x', 'y', 'w', 'h', 'time (ms)'];
      var timestamp;
      var moving;
      var trialState = 0;
      var fs = false;

      p.setup = function () {
        var canvas = p.createCanvas(windowWH[0], windowWH[1]);
        //			canvas.parent('p5sketch');
        canvas.parent('sketchTest');
        canvas.style('display', 'block')
        fs = p.fullscreen(true);

        p.data = new p5.Table();
        for (var i = 0; i < header.length; i++) {
          p.data.addColumn(header[i]);
        }
        moving = true;

        timestamp = p.millis();
      };

      p.draw = function () {

        p.background(255, 255, 255);
        p.fill(0, 0, 0);
        p.textSize(25);
        // Draw Rectangle for screen calibration

        if (moving) {
          p.text(msg1,
            windowWH[0] / 4, 50, windowWH[0] / 2, 200);
          //					p.text(windowWH[0]+'\t'+windowWH[1],50,20);

          w = p.mouseX - x;
          if (w < 0) { w = 10; }
          h = p.mouseY - y;
          if (h < 0) { h = 10; }
        } else {
          p.text(msg2,
            windowWH[0] / 4, 50, windowWH[0] / 2, 200);
        }
        p.fill(128, 0, 0);
        p.rect(x, y, w, h);

      };



      p.mousePressed = function () {
        if (trialState != -1 && moving) {
          moving = false;
        }
      }

      p.keyPressed = function () {

        if (!moving && p.keyCode === 89) {// y pressed
          timestamp = p.millis();
          p.finished();
        } else if (!moving && p.keyCode === 78) { //n pressed
          moving = true;
        }

      }

      p.finished = function () {

        cardPixW = w / BCRW;
        cardPixH = h / BCRH;

        setRes(cardPixW, cardPixH)

        setFullScreenParam(false)
        p.fullscreen(false);
        p.remove();
        resetFullScreen(false)
        endGettingRes()

      }


    };

    var myp5 = new p5(sketch);
  }

}
